import { API } from "@/main";

const state = {
  network: {
    openSidebar: null,
    activeLayers: [],
    selectedTool: null
  }
};

const getters = {
  getCurrentlyOpenTabSidebar: state => state.network.openSidebar,
  getNetworkActiveLayers: state => state.network.activeLayers,
  getSelectedTool: state => state.network.selectedTool
};

const mutations = {
  SET_OPEN_TAB_SIDEBAR(state, tab) {
    state.network.openSidebar = tab;
  },

  SET_ACTIVE_LAYERS(state, layers) {
    state.network.activeLayers = layers;
  },

  /**
   * Sets the selected tool
   * @param {Object} tool - the selected tool
   */
  SET_SELECTED_TOOL(state, tool) {
    state.network.selectedTool = tool;
  }
};

const actions = {
  setOpenTabSidebar({ commit }, tab) {
    commit("SET_OPEN_TAB_SIDEBAR", tab);
  },

  setActiveLayers({ commit }, layers) {
    commit("SET_ACTIVE_LAYERS", layers);
  },

  /**
   * Sets the selected tool
   */
  setSelectedTool({ commit }, selectedTool) {
    commit("SET_SELECTED_TOOL", selectedTool)
  },

  ///////////////////////////
  /*     Tool Actions      */
  ///////////////////////////

  executeFailureAnalysis({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.network.executeFailureAnalysis(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  executeSinglePointFailure({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.network.executeSinglePointFailure(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  ///////////////////////////
  /*   Hierarchy Action    */
  ///////////////////////////

  fetchAllCountries() {
    return new Promise((resolve, reject) => {
      API.network.getAllCountries(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchHierarchyChildrenByType({ commit }, { type, id }) {
    return new Promise((resolve, reject) => {
      API.network.getHierarchyChildrenByType(
        type,
        id,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Network/network.js